import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {
  ExerciceState,
  FetchExercicesResponse,
  FetchExerciceByIdResponse,
  FetchAllExercicesResponse,
} from './types'
import {
  fetchExerciceById,
  fetchExercices,
  createExercice,
  updateExercice,
  deleteExercice,
  endExercice,
  undoExercice,
  fetchAllExercices,
} from './service'
import {ResponseError} from '../commonTypes'

const initialState: ExerciceState = {
  exerciceForEdit: null,
  exercices: [],
  total: 0,
  totalPages: 0,
  listLoading: false,
  actionLoading: false,
  error: null,
}
const exerciceSlice = createSlice({
  name: 'exercice',
  initialState,
  reducers: {
    resetExercices: (state: ExerciceState) => {
      state.exercices = []
      state.total = 0
      state.totalPages = 0
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchExercices.pending, (state: ExerciceState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchExercices.rejected, (state: ExerciceState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.listLoading = false
    })
    builder.addCase(
      fetchExercices.fulfilled,
      (state: ExerciceState, action: PayloadAction<FetchExercicesResponse>) => {
        state.listLoading = false
        state.error = null
        const {exercices, total, totalPages} = action.payload
        state.exercices = exercices
        state.total = total
        state.totalPages = totalPages
      }
    )

    builder.addCase(fetchAllExercices.pending, (state: ExerciceState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(
      fetchAllExercices.rejected,
      (state: ExerciceState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.listLoading = false
      }
    )
    builder.addCase(
      fetchAllExercices.fulfilled,
      (state: ExerciceState, action: PayloadAction<FetchAllExercicesResponse>) => {
        state.listLoading = false
        state.error = null
        const {exercices} = action.payload
        state.exercices = exercices
      }
    )

    builder.addCase(fetchExerciceById.pending, (state: ExerciceState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(
      fetchExerciceById.rejected,
      (state: ExerciceState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.listLoading = false
      }
    )
    builder.addCase(
      fetchExerciceById.fulfilled,
      (state: ExerciceState, action: PayloadAction<FetchExerciceByIdResponse>) => {
        state.exerciceForEdit = action.payload.exercice
        state.listLoading = false
        state.error = null
        state.exerciceForEdit = action.payload.exercice
      }
    )

    builder.addCase(createExercice.pending, (state: ExerciceState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(createExercice.rejected, (state: ExerciceState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      createExercice.fulfilled,
      (state: ExerciceState, action: PayloadAction<FetchExerciceByIdResponse>) => {
        state.exerciceForEdit = action.payload.exercice
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(updateExercice.pending, (state: ExerciceState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(updateExercice.rejected, (state: ExerciceState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      updateExercice.fulfilled,
      (state: ExerciceState, action: PayloadAction<FetchExerciceByIdResponse>) => {
        state.exerciceForEdit = action.payload.exercice
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(deleteExercice.pending, (state: ExerciceState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(deleteExercice.rejected, (state: ExerciceState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      deleteExercice.fulfilled,
      (state: ExerciceState, action: PayloadAction<FetchExerciceByIdResponse>) => {
        state.exerciceForEdit = action.payload.exercice
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(endExercice.pending, (state: ExerciceState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(endExercice.rejected, (state: ExerciceState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      endExercice.fulfilled,
      (state: ExerciceState, action: PayloadAction<FetchExerciceByIdResponse>) => {
        state.exerciceForEdit = action.payload.exercice
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(undoExercice.pending, (state: ExerciceState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(undoExercice.rejected, (state: ExerciceState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(
      undoExercice.fulfilled,
      (state: ExerciceState, action: PayloadAction<FetchExerciceByIdResponse>) => {
        state.exerciceForEdit = action.payload.exercice
        state.actionLoading = false
        state.error = null
      }
    )
  },
})

export default exerciceSlice.reducer
export const actions = exerciceSlice.actions
